import * as React from "react";
import Mobile from "./Help/Mobile";
import {GameGuidelines} from "./Help/";
import withHeader from "../components/Header";
export class Help extends React.Component {
	public render() {
		return (
			<React.Fragment>
				<Mobile />
				<div className="hidden-mobile">
					<GameGuidelines />
				</div>
			</React.Fragment>
		);
	}
}

export default withHeader(Help);
